(function () {
	Vue.component('nominow-customer-edit', {
		props: {
			data: {
				type: Object,
				required: true
			},
			parent: {
				type: Object,
				required: true,
				default: () => ({
					countries: Array,
					languages: Array,
					refreshItem: () => { },
					closemodals: () => { }
				})
			}
		},
		data: function () {
			return {
				error: null,
				item: this.data,
				countries: this.parent.countries,
				languages: this.parent.languages
			};
		},
		template: `
        <div>

        <div class="field is-horizontal has-addon">
            <div class="field-body">

            <div class="field mui-textfield" id="myid1">
                <div class="select is-light">
                    <select v-model="item.GenderId" required>
                        <option value="1" :selected="item.GenderId == 1">Male</option>
                        <option value="2" :selected="item.GenderId == 2">Female</option>
                        <option value="3" :selected="item.GenderId == 3">Unknown</option>
                    </select>
                </div>
                <label>Gender</label>
            </div>

            <nominow-input-text v-model="item.Firstname" label="Firstname"/>
            <nominow-input-text v-model="item.Surname" label="Lastname"/>
            </div>
        </div>
        <nominow-input-text v-model="item.EmailAddress" label="Email" regex-message="invalid email" regex="^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9_\\-\\.]+)\\.([a-zA-Z]{2,9})$"/>
        <nominow-input-text v-model="item.MobileNumber" label="Mobile"/>
        <nominow-input-text v-model="item.PhoneNumber" label="Phone"/>
        <nominow-input-date v-model="item.BirthDate" label="Birthdate"/>

        <div class="field is-horizontal has-addon">
            <div class="field-body">
                <nominow-input-text v-model="item.Street" label="Street"/>
                <div class="field is-narrow is-narrow-xs mui-textfield">
                <input type="text" v-model="item.HouseNumber" name="housnr" />
                <label>Number</label>
                </div>
                <div class="field is-narrow is-narrow-xs mui-textfield">
                <input type="text" v-model="item.HouseNumberAdd" name="housnradd" />
                <label>Addition</label>
                </div>
            </div>
        </div>
        <div class="field is-horizontal has-addon">
            <div class="field-body">
                <div class="field is-narrow mui-textfield">
                    <input type="text" v-model="item.PostalCode" name="zip" />
                    <label>Postalcode</label>
                </div>
                <nominow-input-text v-model="item.City" label="City"/>
            </div>
        </div>
        <div class="mui-textfield">
        <div class="select is-light">
        <select v-model="item.CountryId" name="country">
        <option>--select--</option>
        <option v-for="c in countries" :value="c.CountryId">{{c.CountryName}}</option>
        </select>
        </div>
        <label>Country</label>
        </div>
        <div class="mui-textfield">
        <div class="select is-light">
        <select v-model="item.LanguageId" name="language">
        <option>--select--</option>
        <option v-for="c in languages" :value="c.LanguageId">{{c.LanguageName}}</option>
        </select>
        </div>
        <label>Language</label>
        </div>
        <div class="validation-error" v-if="error != null" style="position:relative;height:20px;">
        <span class="mui-form-helper validation-message">
        {{error}}
        </span>
        </div>
        <div class="has-text-right">
        <button class="button is-primary" v-on:click="store">Save</button>
        </div>
        </div>
        `,
		created: function () {
			if (this.item.BirthDate) {
				this.item.BirthDate = window.formatDate(this.item.BirthDate);
			}
		},
		mounted: function () {
			$('input[name=Firstname]', this.$el).focus();
		},
		methods: {
			getLabel: function (id) {
				if (id == '1') {
					return 'Male';
				}
				if (id == '2') {
					return 'Female';
				}
				return 'Unknown';
			},
			store: function () {
				toggleLoader(true);
				const self = this;
				POST('/baas/nominow_customermanagement/contact', this.item).then(xhr => {
					self.parent.refreshItem(self.item.ContactGuid);
					self.parent.closemodals();
					toggleLoader(false);

				}, xhr => {
					toggleLoader(false);
					self.error = xhr.responseText;
					self.parent.closemodals();
					toggleLoader(false);
				});
			}
		}
	});

	Vue.component('nominow-edit-user', {
		props: {
			data: {
				type: Object,
				required: true
			},
			parent: {
				type: Object,
				required: true,
				default: () => ({
					countries: Array,
					languages: Array,
					refreshItem: () => { },
					closemodals: () => { }
				})
			}
		},
		data: function () {
			return {
				error: null,
				item: this.data,
				countries: this.parent.countries,
				languages: this.parent.languages
			};
		},
		template: `
        <div>

        <div class="field is-horizontal has-addon">
            <div class="field-body">

            <div class="field mui-textfield" id="myid1">
                <div class="select is-light">
                    <select v-model="item.GenderId" required>
                        <option value="1" :selected="item.GenderId == 1">Male</option>
                        <option value="2" :selected="item.GenderId == 2">Female</option>
                        <option value="3" :selected="item.GenderId == 3">Unknown</option>
                    </select>
                </div>
                <label>Gender</label>
            </div>

            <nominow-input-text v-model="item.Firstname" label="Firstname"/>
            <nominow-input-text v-model="item.Surname" label="Lastname"/>
            </div>
        </div>
        <nominow-input-text v-model="item.EmailAddress" label="Email" regex-message="invalid email" regex="^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9_\\-\\.]+)\\.([a-zA-Z]{2,9})$"/>
        <nominow-input-text v-model="item.MobileNumber" label="Mobile"/>
        <nominow-input-text v-model="item.PhoneNumber" label="Phone"/>
        <nominow-input-date v-model="item.BirthDate" label="Birthdate"/>

        <div class="field is-horizontal has-addon">
            <div class="field-body">
                <nominow-input-text v-model="item.Street" label="Street"/>
                <div class="field is-narrow is-narrow-xs mui-textfield">
                <input type="text" v-model="item.HouseNumber" name="housnr" />
                <label>Number</label>
                </div>
                <div class="field is-narrow is-narrow-xs mui-textfield">
                <input type="text" v-model="item.HouseNumberAdd" name="housnradd" />
                <label>Addition</label>
                </div>
            </div>
        </div>
        <div class="field is-horizontal has-addon">
            <div class="field-body">
                <div class="field is-narrow mui-textfield">
                    <input type="text" v-model="item.PostalCode" name="zip" />
                    <label>Postalcode</label>
                </div>
                <nominow-input-text v-model="item.City" label="City"/>
            </div>
        </div>
        <div class="mui-textfield">
        <div class="select is-light">
        <select v-model="item.CountryId" name="country">
        <option>--select--</option>
        <option v-for="c in countries" :value="c.CountryId">{{c.CountryName}}</option>
        </select>
        </div>
        <label>Country</label>
        </div>
        <div class="mui-textfield">
        <div class="select is-light">
        <select v-model="item.LanguageId" name="language">
        <option>--select--</option>
        <option v-for="c in languages" :value="c.LanguageId">{{c.LanguageName}}</option>
        </select>
        </div>
        <label>Language</label>
        </div>
        <div class="validation-error" v-if="error != null" style="position:relative;height:20px;">
        <span class="mui-form-helper validation-message">
        {{error}}
        </span>
        </div>
        <div class="has-text-right">
        <button class="button is-primary" v-on:click="store">Save</button>
        </div>
        </div>
        `,
		created: function () {
			if (this.item.BirthDate) {
				this.item.BirthDate = window.formatDate(this.item.BirthDate);
			}
		},
		mounted: function () {
			console.error('RC: please update to nominow-customer-edit in customer expansions instead of nominow-edit-user!!');
			console.error('RC: please update to nominow-customer-edit in customer expansions instead of nominow-edit-user!!');
			console.error('RC: please update to nominow-customer-edit in customer expansions instead of nominow-edit-user!!');
			$('input[name=Firstname]', this.$el).focus();
		},
		methods: {
			getLabel: function (id) {
				if (id == '1') {
					return 'Male';
				}
				if (id == '2') {
					return 'Female';
				}
				return 'Unknown';
			},
			store: function () {
				toggleLoader(true);
				const self = this;
				POST('/baas/nominow_customermanagement/contact', this.item).then(xhr => {
					self.parent.refreshItem(self.item.ContactGuid);
					self.parent.closemodals();
					toggleLoader(false);

				}, xhr => {
					toggleLoader(false);
					self.error = xhr.responseText;
					self.parent.closemodals();
					toggleLoader(false);
				});
			}
		}
	});

	Vue.component('nominow-customer-code-edit', {
		props: {
			data: {
				type: Object,
				required: true
			},
			parent: {
				type: Object,
				required: true,
				default: () => ({
					countries: Array,
					languages: Array,
					refreshItem: () => { },
					closemodals: () => { }
				})
			}
		},
		data: function () {
			return {
				error: null,
				item: this.data,
				countries: this.parent.countries,
				languages: this.parent.languages
			};
		},
		template: `
        <div>

        <div class="field is-horizontal has-addon">
            <div class="field-body">

            <div class="field mui-textfield" id="myid1">
                <div class="select is-light">
                    <select v-model="item.GenderCode" required>
                        <option value="M">Male</option>
                        <option value="F">Female</option>
                        <option value="U">Unknown</option>
                        <option value="G">Genderqueer</option>
                    </select>
                </div>
                <label>Gender</label>
            </div>

            <nominow-input-text v-model="item.Firstname" label="Firstname"/>
            <nominow-input-text v-model="item.Surname" label="Lastname"/>
            </div>
        </div>
        <nominow-input-text v-model="item.EmailAddress" label="Email" regex-message="invalid email" regex="^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9_\\-\\.]+)\\.([a-zA-Z]{2,9})$"/>
        <nominow-input-text v-model="item.MobileNumber" label="Mobile"/>
        <nominow-input-text v-model="item.PhoneNumber" label="Phone"/>
        <nominow-input-date v-model="item.BirthDate" label="Birthdate"/>

        <div class="field is-horizontal has-addon">
            <div class="field-body">
                <nominow-input-text v-model="item.Street" label="Street"/>
                <div class="field is-narrow is-narrow-xs mui-textfield">
                <input type="text" v-model="item.HouseNumber" name="housnr" />
                <label>Number</label>
                </div>
                <div class="field is-narrow is-narrow-xs mui-textfield">
                <input type="text" v-model="item.HouseNumberAdd" name="housnradd" />
                <label>Addition</label>
                </div>
            </div>
        </div>
        <div class="field is-horizontal has-addon">
            <div class="field-body">
                <div class="field is-narrow mui-textfield">
                    <input type="text" v-model="item.PostalCode" name="zip" />
                    <label>Postalcode</label>
                </div>
                <nominow-input-text v-model="item.City" label="City"/>
            </div>
        </div>
        <div class="mui-textfield">
        <div class="select is-light">
        <select v-model="item.CountryCode" name="country">
        <option>--select--</option>
        <option v-for="c in countries" :value="c.CountryCode">{{c.CountryName}}</option>
        </select>
        </div>
        <label>Country</label>
        </div>
        <div class="mui-textfield">
        <div class="select is-light">
        <select v-model="item.LanguageCode" name="language">
        <option>--select--</option>
        <option v-for="c in languages" :value="c.LanguageCode">{{c.LanguageName}}</option>
        </select>
        </div>
        <label>Language</label>
        </div>
        <div class="validation-error" v-if="error != null" style="position:relative;height:20px;">
        <span class="mui-form-helper validation-message">
        {{error}}
        </span>
        </div>
        <div class="has-text-right">
        <button class="button is-primary" v-on:click="store">Save</button>
        </div>
        </div>
        `,
		created: function () {
			vuelog(this.item);
			if (this.item.BirthDate) {
				this.item.BirthDate = window.formatDate(this.item.BirthDate);
			}
		},
		mounted: function () {
			$('input[name=Firstname]', this.$el).focus();
		},
		methods: {
			store: function () {
				toggleLoader(true);
				const self = this;
				POST('/baas/nominow_customermanagement/contact', this.item).then(xhr => {
					self.parent.refreshItem(self.item.ContactGuid);
					self.parent.closemodals();
					toggleLoader(false);

				}, xhr => {
					toggleLoader(false);
					self.error = xhr.responseText;
					self.parent.closemodals();
					toggleLoader(false);
				});
			}
		}
	});

})();
